import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MersyMassReleaseRevokeDto } from '../../../../../interfaces/mersymassreleaserevokedto';
import { SummaryComponent } from './summary/summary.component';
import { UserMgmtBranch } from '../../../../usermngportal/home/edituser/usermgmtbranch/usermgmtbranch.component';
import { ChangelogDialogComponent, ChangelogDialogConfig } from '../../../shared-components/changelog-dialog/changelog-dialog.component';
import { TableColumn } from '../../../shared-components/data-table/data-table.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FiscalYearComponent } from '../../../../fiscalyear/fiscalyear.component';
import { OPLVersionComponent } from '../../../../oplversion/oplversion';
import { PeriodComponent } from '../../../../period/period.component';
import { OwnergroupfunctionComponent } from './ownergroupfunction/ownergroupfunction.component';

@Component({
    selector: 'massreleaserevoke',
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        FiscalYearComponent,
        OPLVersionComponent,
        PeriodComponent,
        UserMgmtBranch,
        OwnergroupfunctionComponent
    ],
    templateUrl: './massreleaserevoke.component.html',
    styleUrls: ['./massreleaserevoke.component.less']
})

export class MassreleaserevokeComponent{
    @ViewChild(UserMgmtBranch) branchComponent!: UserMgmtBranch;
    public mersyMassReleaseRevokeDto: MersyMassReleaseRevokeDto = {} as MersyMassReleaseRevokeDto ;
    dialogRef: MatDialogRef<SummaryComponent, any> | undefined


    constructor(
        private readonly dialogForm: MatDialog,
        private readonly route: ActivatedRoute,
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string,
    )
    {

    }

    updateMgmtDetails(dto: MersyMassReleaseRevokeDto) {
        this.mersyMassReleaseRevokeDto.Mgmtids = dto.Mgmtids;
        this.mersyMassReleaseRevokeDto.NodeGF = dto.NodeGF;
        this.mersyMassReleaseRevokeDto.HierarchyType = dto.HierarchyType;
        this.mersyMassReleaseRevokeDto.OPLType = dto.OPLType;
        console.log('All prams', this.mersyMassReleaseRevokeDto);
    }
    updateKPIOwners(selectedkpiOwner: string[]) {
        this.mersyMassReleaseRevokeDto.OwnerGF = selectedkpiOwner;
        console.log('All prams', this.mersyMassReleaseRevokeDto);
    }
    updatePeriods(dto: MersyMassReleaseRevokeDto) {
        this.mersyMassReleaseRevokeDto.Periods = dto.Periods
        console.log('All prams', this.mersyMassReleaseRevokeDto);
    }
    public isButtonDisabled() {
        return !(this.mersyMassReleaseRevokeDto?.HierarchyType && this.mersyMassReleaseRevokeDto.Mgmtids?.length > 0)
    }

    openChangelog() {
        const columns: TableColumn[] = [
            { key: 'createdAtUtc', header: 'Date (UTC)', formatter: (v) => new Date(v).toLocaleString(), align: 'center' },
            { key: 'createdBy', header: 'User', align: 'center' },
            { key: 'actionType', header: 'Action', align: 'center' },
            { key: 'type', header: 'Type', align: 'center' },
            { key: 'fiscalYear', header: 'Fiscal Year', formatter: (v) => `${v - 1}/${v}`, align: 'center' },
            { key: 'periods', header: 'Periods' },
            { key: 'mgmtIds', header: 'Management IDs',
                formatter: (v) => {
                    if (!v) return '-';
                    const ids = v.split(',').map((s: string) => s.trim());
                    return ids.length > 4 ? ids.slice(0, 4).join(', ') + ` ... (+${ids.length - 4})` : ids.join(', ');
                },
                tooltip: (v) => v || ''
            },
            { key: 'ownerGF', header: 'Owner GF', align: 'center' },
            { key: 'success', header: 'Success', formatter: (v) => v ? 'Yes' : 'No', align: 'center' },
        ];

        const config: ChangelogDialogConfig = {
            title: 'Mass Release/Revoke Changelog',
            apiEndpoint: 'api/KPIManagement/massReleaseRevoke/changelog',
            columns: columns,
            backButtonText: 'Back',
            alternateRowColors: true
        };

        this.dialogForm.open(ChangelogDialogComponent, {
            width: '95vw',
            data: config
        });
    }

    openReleaseRevokdialog(ActionType: string) {
        this.mersyMassReleaseRevokeDto.ActionType = ActionType;
        this.dialogRef = this.dialogForm.open(SummaryComponent, {
            height: '540px',
            width: '600px',
            data: this.mersyMassReleaseRevokeDto,
            disableClose: true
        });
        this.dialogRef.afterClosed().subscribe(() => {
        });
    }

}
